import { Directive, ElementRef, HostListener, inject, Input } from '@angular/core';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';

@Directive({
  selector: '[appEllipsisTooltip]',
  standalone: true,
  hostDirectives: [MatTooltip]
})
export class EllipsisTooltipDirective {
  private matTooltip = inject(MatTooltip);
  private elRef = inject(ElementRef<HTMLElement>);

  @Input('appEllipsisTooltip') set appEllipsisTooltip(value: string) {
    this.matTooltip.message = value;
  }

  @Input() position: TooltipPosition = 'below';

  @HostListener('mouseenter')
  onMouseEnter() {
    const element = this.elRef.nativeElement;
    const isTruncated = element.scrollWidth > element.clientWidth;
    this.matTooltip.position = this.position;
    this.matTooltip.disabled = !isTruncated;
  }
}
